/* eslint-disable eqeqeq */
import { RegInShoppingCartRequest } from 'src/app/core/dtos/dto';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import { PersonalLookupInfoForTestRegistrationDto, TestSessionForRegistrationDto } from 'src/app/core/dtos/dto';
import { ProofOfIdentityPageSaveInfo, ScoreReportPageSaveInfo } from 'src/app/core/dtos/reg-data';
import { Step } from 'src/app/core/dtos/step';
import { TestPurposeOption } from 'src/app/core/dtos/test-purpose-option';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { DateTimeHelper } from 'src/app/core/services/helpers/date-time.helper';
import { RegWorkflowMappingService } from 'src/app/core/services/reg-workflow-mapping.service';
import { RegistrationService } from 'src/app/core/services/registration.service';
import { PageStepEnum, StepProgressService } from 'src/app/core/services/step-progress.service';
import { selectProofOfIdentity, selectRegTestSession, selectScoreReport, selectTestPurposeOption } from 'src/app/state/reg-data.selectors';
import { BrandEnum, RegWorkflowEnum } from 'src/app/core/dtos/enum';
import { NavigationRoute } from 'src/app/core/constants/constants';
import { loadShoppingCart } from 'src/app/state/shopping-cart.actions';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { setProofOfIdentity } from 'src/app/state/reg-data.actions';
import { take } from 'rxjs/operators';


@Component({
  selector: 'app-test-summary',
  templateUrl: './test-summary.component.html',
  styleUrls: ['./test-summary.component.scss']
})
export class TestSummaryComponent implements OnInit, OnDestroy {
  testSessionInformation$: Observable<TestSessionForRegistrationDto>;
  proofOfIdentityPageSaveInfo$: Observable<ProofOfIdentityPageSaveInfo>;
  testPurposeOption$: Observable<TestPurposeOption>;
  scoreReportPageSaveInfo$: Observable<ScoreReportPageSaveInfo>;

  testSessionInformationSubscription: Subscription;
  proofOfIdentityPageSaveInfoSubscription: Subscription;
  testPurposeOptionSubscription: Subscription;
  personalLookupSubscription: Subscription;
  selectedScoreReportSubscription: Subscription;

  postRegShoppingCartSubscription: Subscription;

  testSessionInformation: TestSessionForRegistrationDto;
  proofOfIdentityPageSaveInfo: ProofOfIdentityPageSaveInfo;
  testPurposeOption: TestPurposeOption;
  personalLookupInfo: PersonalLookupInfoForTestRegistrationDto;

  pagePath = NavigationRoute.REGISTRATION.testSummary;
  regWorkFlow: RegWorkflowEnum;
  wordPressUrl: string;
  steps: Step[];

  isConfirmation: boolean = false;

  //Test Purpose
  testDate: Date;
  testTypeCssClass: string;
  testPurposeDisplay: string;

  //TestCentre
  testCentreCountry: string;

  //Proof of Identity
  identityDocumentType: string;
  countryOfCitizenship: string;
  gender: string;
  firstLanguage: string;

  //Brand Info
  brandId: BrandEnum;

  //Score Report
  expressShipping = false;
  priorityShipping = false;
  shippingRequiredScoreLevelId: number;
  localTimeZone: string;

  constructor(
    private regWorkflowMappingService: RegWorkflowMappingService,
    private router: Router,
    private stepProgressServiceService: StepProgressService,
    private toastService: HotToastService,
    private registrationService: RegistrationService,
    private configHelper: ConfigHelper,
    private store: Store,
    private dateTimeHelper: DateTimeHelper
  ) {
    this.steps = this.stepProgressServiceService.getSteps(PageStepEnum.ReviewAndAddToCart);
  }

  ngOnInit(): void {
    this.brandId = this.configHelper.getBrandId();
    this.wordPressUrl = this.configHelper.getWordPressUrl();
    this.localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    this.testPurposeOption$ = this.store.pipe(select(selectTestPurposeOption));
    this.testPurposeOptionSubscription = this.testPurposeOption$
      .subscribe(testPurposeOption => {
        this.testPurposeOption = testPurposeOption;
        this.renderDependentValues();
      });

    this.testSessionInformation$ = this.store.pipe(select(selectRegTestSession));
    this.testSessionInformationSubscription = this.testSessionInformation$.pipe(take(1))
      .subscribe(testSessionInformation => {
        this.testSessionInformation = testSessionInformation;
        const testDateUtcToLocal = this.dateTimeHelper.convertUTCDateToLocalDate(new Date(testSessionInformation.testDateTimeUtc));
        this.testDate = testSessionInformation.isWebDelivery ? testDateUtcToLocal : testSessionInformation.testDateTimeTestCentre;
        this.testTypeCssClass = this.configHelper.getTestTypeCssClass(this.testSessionInformation?.testTypeId);
        this.renderDependentValues();
        this.regWorkFlow = this.regWorkflowMappingService.getRegWorkFlow(testSessionInformation);
      });

    this.proofOfIdentityPageSaveInfo$ = this.store.pipe(select(selectProofOfIdentity));
    this.proofOfIdentityPageSaveInfoSubscription = this.proofOfIdentityPageSaveInfo$.pipe(take(1))
      .subscribe(proofOfIdentityPageSaveInfo => {
        if (proofOfIdentityPageSaveInfo) {
          this.proofOfIdentityPageSaveInfo = proofOfIdentityPageSaveInfo;
        }
        else {
          this.registrationService.getIdentityInfo()
            .subscribe(
              (result) => {
                const proofOfIdentityInfo = {
                  siteCode: this.testSessionInformation?.siteCode,
                  testTypeId: this.testSessionInformation?.testTypeId,
                  countryId: result.content.citizenshipCountryId,
                  firstName: result.content.firstName,
                  middleName: result.content.middleName,
                  lastName: result.content.lastName,
                  dateOfBirth: result.content.birthDate,
                  documentTypeId: result.content.idDocTypeId,
                  documentNumber: result.content.idDocNumber,
                  documentExpiryDate: result.content.idDocExpiryDate,
                  firstLanguageId: result.content.firstLanguageId,
                  gender: result.content.gender,
                  documentConfirm: true,
                  skipLastName: result.content.lastName.length > 0
                };
                this.proofOfIdentityPageSaveInfo = proofOfIdentityInfo;
              });
        }
        this.gender = this.proofOfIdentityPageSaveInfo?.gender === "M" ? "Male" : "Female";
        this.renderDependentValues();
      });

    this.personalLookupSubscription = this.registrationService.getRegPersonalLookupInfo(this.testSessionInformation.testCentreCountryId, this.testPurposeOption.testPurposeId, this.testSessionInformation.testTypeId, this.testSessionInformation.testCentreId)
      .subscribe(
        value => {
          this.personalLookupInfo = value.content;
          this.renderDependentValues();
        },
        () => this.toastService.warning("Unable to retrieve Proof of Identity Registration options."));

    this.scoreReportPageSaveInfo$ = this.store.pipe(select(selectScoreReport));
    this.selectedScoreReportSubscription = this.scoreReportPageSaveInfo$
      .subscribe(scoreReportPageSaveInfo => {
        this.priorityShipping = scoreReportPageSaveInfo?.priorityShipping;
        this.expressShipping = scoreReportPageSaveInfo?.expressRating;
        this.shippingRequiredScoreLevelId = scoreReportPageSaveInfo?.testScoresOptionDto?.shippingRequiredScoreLevelId;
      });
  }

  public get BrandEnum() {
    return BrandEnum;
  }

  ngOnDestroy() {
    this.testSessionInformationSubscription?.unsubscribe();
    this.testPurposeOptionSubscription?.unsubscribe();
    this.proofOfIdentityPageSaveInfoSubscription?.unsubscribe();
    this.personalLookupSubscription?.unsubscribe();
    this.selectedScoreReportSubscription?.unsubscribe();
  }

  renderDependentValues() {
    if (this.testPurposeOption && this.testSessionInformation && this.proofOfIdentityPageSaveInfo && this.personalLookupInfo) {
      //equality compare does not work between the number type id with ===
      this.countryOfCitizenship = this.personalLookupInfo.countries.find(x => x.id == this.proofOfIdentityPageSaveInfo.countryId)?.name;
      this.testCentreCountry = this.personalLookupInfo.countries.find(x => x.id == this.testSessionInformation.testCentreCountryId)?.name;
      this.identityDocumentType = this.personalLookupInfo.idDocTypes.find(x => x.id == this.proofOfIdentityPageSaveInfo.documentTypeId)?.name;
      this.firstLanguage = this.personalLookupInfo.languages.find(x => x.id == this.proofOfIdentityPageSaveInfo.firstLanguageId)?.name;
    }
  }

  redirectTestSelection() {
    if (this.testSessionInformation.isWebDelivery) {
      this.router.navigate(['/registration/sitting-selection-web-delivery']);
    } else {
      this.router.navigate(['/registration/sitting-selection']);
    }
  }

  redirectProofOfIdentity() {
    this.router.navigate(['/registration/proof-of-identity']);
  }

  redirectNextStep() {
    const nextStep = this.regWorkflowMappingService.getNextStepNew(this.regWorkFlow, this.pagePath);
    this.router.navigate([nextStep]);
  }

  addToCart() {
    if (!this.isConfirmation) {
      this.toastService.warning("Please confirm that you have read and understood the statement regarding arrival time in Test Summary.");
      return;
    };
    const regInShoppingCartRequest: RegInShoppingCartRequest = {
      isExpressScoring: this.expressShipping,
      isPriorityShipping: this.priorityShipping,
      shippingRequiredScoreLevelId: this.shippingRequiredScoreLevelId
    };
    this.postRegShoppingCartSubscription = this.registrationService.postRegShoppingCart(regInShoppingCartRequest).subscribe(
      (result) => {
        this.store.dispatch(loadShoppingCart({ shoppingCart: result.content }));
        this.redirectNextStep();
      },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
          });
        }
      });
  }

}
